import script from "./whDOnceImg6_t1A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg6_t1A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg6_t1A.vue?vue&type=style&index=0&id=82961ecc&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82961ecc"]])

export default __exports__